export const initialState = {
  loading: false,
  subcategory: {},
  subcategories: [],
  response: { message: null, error: null },

};
